import Phaser from 'phaser';
import { TEXTURE_KEYS } from '../assets/assetKeys';
import { Quest } from '../data/quests';
import { ResponsiveSystem } from '../systems/ResponsiveSystem';
import { UIStyle } from './UIStyle';

export class QuestPanel {
  private scene: Phaser.Scene;
  private container?: Phaser.GameObjects.Container;
  private lastCurrent?: Quest | null;
  private unbindResize?: () => void;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  show(_quests: Quest[], currentQuest?: Quest | null): void {
    this.lastCurrent = currentQuest ?? null;
    this.render();

    if (!this.unbindResize) {
      this.unbindResize = ResponsiveSystem.onResize(() => {
        if (this.container) this.render();
      });
    }
  }

  private render(): void {
    this.hide(false);

    const isCompact = ResponsiveSystem.isMobile(this.scene);
    const safe = ResponsiveSystem.getSafeBounds(this.scene.game, {
      top: isCompact ? 74 : 84,
      left: 14,
    });
    const panelW = isCompact ? 260 : 300;

    const current = this.lastCurrent ?? null;
    const missionTitle = current?.title ?? 'Semua misi selesai';
    const missionDesc = current?.description ?? 'Zona ini sudah rampung. Lanjutkan perjalanan.';

    const titleStyle = UIStyle.panelTitle(isCompact ? UIStyle.px(16) : UIStyle.px(18));
    const missionStyle = UIStyle.panelBody(isCompact ? UIStyle.px(15) : UIStyle.px(16));
    const descStyle = UIStyle.panelMuted(isCompact ? UIStyle.px(13) : UIStyle.px(14));

    const header = this.scene.add.text(0, 0, 'Misi Zona', titleStyle);
    const mission = this.scene.add.text(0, 0, `▶ ${missionTitle}`, {
      ...missionStyle,
      wordWrap: { width: panelW - 24 },
      lineSpacing: 3,
    });
    const description = this.scene.add.text(0, 0, missionDesc, {
      ...descStyle,
      wordWrap: { width: panelW - 24 },
      lineSpacing: 3,
    });

    const contentH = header.height + 8 + mission.height + 8 + description.height;
    const panelH = Math.max(isCompact ? 96 : 104, contentH + 24);

    header.setPosition(12, 10);
    mission.setPosition(12, 10 + header.height + 8);
    description.setPosition(12, mission.y + mission.height + 8);

    this.container = this.scene.add.container(safe.left, safe.top);

    const bg = this.scene.add.image(0, 0, TEXTURE_KEYS.UI_QUEST);
    bg.setDisplaySize(panelW, panelH);
    bg.setOrigin(0, 0);

    this.container.add([bg, header, mission, description]);
    this.container.setDepth(50);
    this.container.setScrollFactor(0);
  }

  hide(clearState = true): void {
    this.container?.destroy();
    this.container = undefined;
    if (clearState) {
      this.lastCurrent = undefined;
      this.unbindResize?.();
      this.unbindResize = undefined;
    }
  }

  setVisible(visible: boolean): void {
    this.container?.setVisible(visible);
  }

  destroy(): void {
    this.hide();
  }
}
